import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import cn from "classnames";
import { getSeasons } from "../../../api";
import { Season } from "../../../types/season";
import HistoryIcon from "./history-icon";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const SeasonHistory = () => {
  const navigate = useNavigate();
  const { seasonId } = useParams();
  const [searchParams] = useSearchParams();
  const defaultExpanded = !!searchParams.get("expanded");
  const [seasons, setSeasons] = useState<Season.Season[]>([]);
  const [expanded, setExpanded] = useState(defaultExpanded);
  const curId = Number(seasonId);

  useEffect(() => {
    getSeasons().then((res) => {
      setSeasons(res);
    });
  }, []);

  const gotoSeason = (id: number) => {
    navigate(`/season/${id}/tasks?expanded=true`);
  };

  const renderStatus = (status: Season.SeasonStatus) => {
    switch (status) {
      case "doing":
        return <div className={cn(styles.status, styles.doing)}>进行中</div>;
      case "not_start":
        return <div className={cn(styles.status, styles.notStart)}>未开始</div>;
      case "end":
        return <div className={cn(styles.status, styles.end)}>已结束</div>;
      default:
        return null;
    }
  };

  // 只取月份和日期
  const renderDate = (season: Season.Season) => {
    const start = season.start_day.slice(5, 10).replace("-", ".");
    const end = season.end_day.slice(5, 10).replace("-", ".");
    return <div className={styles.date}>{`${start} - ${end}`}</div>;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title} onClick={() => setExpanded(true)}>
          <HistoryIcon />
          {expanded && "活动记录"}
        </div>
        {expanded && (
          <div className={styles.close} onClick={() => setExpanded(false)}>
            收起
          </div>
        )}
      </div>
      {expanded && (
        <div className={styles.content}>
          {seasons
            .filter(({ my_team }) => !!my_team)
            .map((season) => (
              <div
                className={cn(
                  styles.season,
                  curId === season.id && styles.active
                )}
                key={season.id}
                onClick={() => gotoSeason(season.id)}
              >
                <div className={styles.name}>{season.name}</div>
                <div className={styles.info}>
                  {renderStatus(season.time_status)}
                  {renderDate(season)}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default SeasonHistory;
